module.exports = __webpack_public_path__ + "img/zh-tw.45ef6b69.svg";